export default __webpack_public_path__ + "static/media/2_search_rate.32a62f88.csv";